import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from "@mui/material";

const services = [
  {
    title: "Digital Marketing",
    description:
      "We've got your back with digital marketing! Our strategies are all about connecting your brand with the right folks, right where they hang out, and at just the right moment. Whether it's SEO, PPC, or social media, we’re here to help you navigate the ever-changing digital world.",
  },
  {
    title: "Lead Generation",
    description:
      "Lead generation is super important for growing your business. We use smart, data-driven methods to bring in quality leads, making sure your sales funnel is packed with people who are really interested in what you offer. Our lead gen strategies are customized just for you and your target audience.",
  },
  {
    title: "Branding & Management",
    description:
      "Your brand’s reputation is everything! Our branding and management services help you build and keep a strong brand identity. We whip up memorable branding strategies and make sure your message stays consistent across all your digital platforms.",
  },
];

const ExpertiseSection = () => {
  return (
    <Box
      sx={{
        // background: "#000",
        color: "white",
        padding: { xs: "20px 20px", md: "40px 40px" },
      }}
    >
      <Container>
        <Typography
          sx={{
            margin: "0 auto",
            color: "#fff",
            textAlign: "center",
            maxWidth: 1000,
            marginBottom: "5%",
            fontSize: "18px",
          }}
        >
          In today's technologically advanced, fast-paced world, digital
          marketing has become a vital and essential tactic for companies hoping
          to succeed online. Connecting with your audience at the correct time,
          location, and with the right message is both an art and a science. The
          field of digital marketing provides a wide range of tools and
          strategies aimed at increasing brand awareness, interacting with
          consumers, and spurring expansion, from SEO and social media
          management to pay-per-click advertising and content marketing. We,
          with DigiTally are your partners as you navigate this thrilling
          adventure, using digital marketing to propel your company to new
          heights.
        </Typography>
      </Container>
      <Container>
        <Typography
          sx={{ color: "#DADFEF", textAlign: "center", fontSize: "25px" }}
          fontWeight="bold"
          gutterBottom
        >
          Utilize Our Expertise in
        </Typography>
        <Typography
          sx={{ textAlign: "center", fontSize: "25px" }}
          fontWeight="bold"
          color="#DADFEF"
          gutterBottom
        >
          Digital Marketing and Content Creation to Boost Your Brand
        </Typography>
        <Typography
          sx={{
            fontSize: "18px",
            maxWidth: 1000,
            mx: "auto",
            mb: 4,
            color: "white",
            textAlign: "center",
          }}
        >
          We at Europa Solutions are committed to assisting your brand in
          becoming the best it can be online. Our strategy to propel your
          brand’s success is centered on our core services: Digital Marketing,
          Lead Generation, and Branding & Management. We can help your business
          in the following ways:
        </Typography>

        <Grid container spacing={3}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  background: "linear-gradient(135deg, #BEBFF4, #2D30AB)",
                  color: "#fff",
                  boxShadow: 3,
                  borderRadius: 3,
                  //   p: 2,
                  border: "3px solid",
                  // borderImage: "linear-gradient(to right, #2D30AB, #9D3DBA)",
                  "&:hover": {
                    background: "linear-gradient(to bottom, grey, #6F1CA3)",
                  },
                  minHeight: { md: "300px", sm: "auto" },
                  maxHeight: { md: "300px", sm: "auto" },
                }}
              >
                <CardContent>
                  <Typography
                    fontWeight="bold"
                    sx={{ color: "#fff", fontSize: "20px" }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "#fff",
                      fontSize: "16px",
                      lineHeight: 1.8,
                    }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ExpertiseSection;
